import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonService } from '../../../../commons/services/common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import moment from 'moment';
import { runInThisContext } from 'vm';

@Component({
    selector: 'app-plus-prest',
    templateUrl: './plus-prest.component.html',
    styleUrls: ['./plus-prest.component.css'],
    standalone: false
})
export class PlusPrestComponent implements OnInit {
  @Input() locationMateriel
  @Input() listeLocationsSupplementaires = [];
  @Input() dataMotifSuppression = [];
  @Input() param;
  @Input() equipes;
  // @Input() isEdit;

  @ViewChild('msg') msg;
  @ViewChild('templateSupressionFille') templateSupressionFille;

  @Output() hidefunction = new EventEmitter<any>();
  @Output() validefunction = new EventEmitter<any>();
  @Output() annuleUneLocation = new EventEmitter<any>();


  selectedLocation: any = {};
  isEditLocation: Boolean = false;
  isEdit: Boolean = false;
  isModeEquipe: Boolean = false;
  objEquipe: any = {};
  is_recreate: Boolean = false;
  copyEquipe;
  motifAnnulationFille = '';
  rowToDelete;
  heightTableau: any = 'auto';
  motifSuppression = {};

  constructor(public common: CommonService, private modalService: BsModalService) {
  }

  ngOnInit() {
    console.log(this.listeLocationsSupplementaires);
    this.copyEquipe = Object.assign({}, this.equipes);
    console.log('________  this.equipes _________', this.equipes);
    this.calcHeightTab();
  }

  calcHeightTab() {
    const ContPlusPrest = $('.slide-prestation').height() - 80;
    const heightTab = ((this.listeLocationsSupplementaires.length + 1) * 30) + 100;
    this.heightTableau = heightTab >= ContPlusPrest ? `calc(100% - 71px)` : 'auto';

    console.log(this.heightTableau)
  }

  fermer() {
    this.showFiche();
  }

  save() {
    this.validefunction.emit(this.listeLocationsSupplementaires);
  }

  deleteLigne(row) {
    console.log('Calling deleteLigne location', row);
    if (row.id) {
      this.rowToDelete = row;
      if (this.dataMotifSuppression && this.dataMotifSuppression.length) {
        this.motifSuppression = this.dataMotifSuppression[0];
      }
      this.common.openModal(this.modalService, this.templateSupressionFille);
    } else {
      this.rowToDelete = row;
      const temp = this.listeLocationsSupplementaires.filter(elt => elt !== this.rowToDelete);
      this.listeLocationsSupplementaires = [...temp];
    }
  }

  confirmDeleteBonFille() {
    if (this.dataMotifSuppression && this.dataMotifSuppression.length) {
      this.motifAnnulationFille = this.motifSuppression && this.motifSuppression['id'] && !this.motifAnnulationFille ?
        (this.motifSuppression['libelle'] || this.motifSuppression['libelleObjetEntite']) : this.motifAnnulationFille;
    }
    this.rowToDelete['annule'] = true;
    this.rowToDelete['motifAnnulation'] = this.motifAnnulationFille;
    this.rowToDelete['motifSuppressionEcoloc'] = this.motifSuppression || { id: 0 };

    const temp = this.listeLocationsSupplementaires.filter(elt => elt !== this.rowToDelete);
    this.listeLocationsSupplementaires = temp;
    this.calcHeightTab();
    this.annuleUneLocation.emit(this.rowToDelete);
    this.common.closeModal();
  }

  showFiche() {
    this.hidefunction.emit();
  }

  // Modif une location
  showFormEditLocation(row?) {
    this.selectedLocation = Object.assign({}, row);
    this.isEditLocation = !this.isEditLocation;

    if (row) {
      this.isEdit = true;
      if (!this.selectedLocation.heureDebut) {
        this.selectedLocation.heureDebut = '00:00:00';
      }

      if (!this.selectedLocation.heureFin) {
        this.selectedLocation.heureFin = '00:00:00';
      }

      this.selectedLocation['dateStart'] = this.common.parseDate(this.selectedLocation.dateDebut);
      this.selectedLocation['dateEnd'] = this.common.parseDate(this.selectedLocation.dateFin);
      this.selectedLocation['hourStart'] = this.selectedLocation.heureDebut.slice(0, -6);
      this.selectedLocation['minStart'] = this.selectedLocation.heureDebut.slice(3).slice(0, -3);
      this.selectedLocation['hourEnd'] = this.selectedLocation.heureFin.slice(0, -6);
      this.selectedLocation['minEnd'] = this.selectedLocation.heureFin.slice(3).slice(0, -3);
    } else {
      this.isEdit = false;
    }

    if (this.param.ecolocEquipe) {
      this.preparerObjetEquipe();
    }
  }

  // Ajouter une location
  newFormEditLocation() {
    this.selectedLocation = {
      nomclass: 'LocationMateriel',
      horsProgram: true
    };
    this.isEdit = false;
    if (this.locationMateriel && this.locationMateriel['numContrat']) {
      this.selectedLocation['numContrat'] = this.locationMateriel['numContrat'];
    }

    if (this.locationMateriel && this.locationMateriel['chantier']) {
      this.selectedLocation['chantier'] = this.locationMateriel['chantier'];
    }

    if (this.locationMateriel && this.locationMateriel.dateDebut) {
      this.selectedLocation['dateStart'] = this.common.parseDate(this.locationMateriel.dateDebut);
      this.selectedLocation['dateEnd'] = this.common.parseDate(this.locationMateriel.dateFin);
    } else if (this.locationMateriel && this.locationMateriel.dateStart) {
      this.selectedLocation['dateStart'] = this.locationMateriel.dateStart;
      this.selectedLocation['dateEnd'] = this.locationMateriel.dateEnd;
    } else {
      this.selectedLocation['dateStart'] = moment();
      this.selectedLocation['dateEnd'] = moment();
    }

    this.selectedLocation['hourStart'] = '00:00:00'.slice(0, -6);
    this.selectedLocation['minStart'] = '00:00:00'.slice(3).slice(0, -3);
    this.selectedLocation['hourEnd'] = '00:00:00'.slice(0, -6);
    this.selectedLocation['minEnd'] = '00:00:00'.slice(3).slice(0, -3);

    if (this.locationMateriel && this.locationMateriel['materielLoue']) {
      this.selectedLocation['materielLoue'] = this.locationMateriel['materielLoue'];
    }

    if (this.param.ecolocEquipe) {
      this.selectedLocation['isAdd'] = true;
      this.preparerObjetEquipe();
    }
    this.calcHeightTab();

    this.isEditLocation = !this.isEditLocation;
  }


  preparerObjetEquipe() {
    let clefChantierRow = this.selectedLocation['chantier'] && this.selectedLocation['chantier'].id ?
      this.selectedLocation['chantier'].id : 0;
    let clefChantierMere = this.locationMateriel && this.locationMateriel['chantier'] && this.locationMateriel['chantier'].id ?
      this.locationMateriel['chantier'].id : 0;
    let clefChantier = clefChantierRow || clefChantierMere;

    if (clefChantier) {
      this.getDetailChantier(clefChantier).then(datas => {
        if (datas.data && datas.data.length) {
          const detailChantier = datas.data[0];
          this.objEquipe['listLieu'] = detailChantier['listLieu'] || [];
        }
      });
    }
    this.parseMouvement();
  }

  parseMouvement() {
    const ctrl = this;
    const planning = this.selectedLocation;
    const isAdd = this.selectedLocation['isAdd'] || false;
    const data = Object.assign({}, this.selectedLocation);
    data['listePersonnelParPoste'] = data['listePersonnelParPoste'] || [];
    ctrl.objEquipe['listePersonnelParPoste'] = [];
    const poctuelPost = [];
    data['listePersonnelParPoste'].forEach(e => {
      const elt = Object.assign({}, e);
      elt.chauffeur = elt.chauffeur || { id: 0 };
      elt.chauffeur['libelleObjetEntite'] = elt.chauffeur && elt.chauffeur.id ? `${elt.chauffeur['matricule'] ||
        ''} ${elt.chauffeur['nom'] || ''} ${elt.chauffeur['prenom'] || ''}` : '';
      elt['lieuChantier'] = elt['chauffeur'] ?
        elt['chauffeur'].lieuChantier : { id: 0, libelleObjetEntite: 'Non spécifié' };
      elt['lieuDepart'] = elt['chauffeur'] ?
        elt['chauffeur'].lieuDepart : { id: 0, libelleObjetEntite: 'Non spécifié' };
      poctuelPost.push(elt);
    });


    ctrl.objEquipe['site'] = planning['site'];
    ctrl.objEquipe['modeEquipe'] = planning['equipeDefinie'] || false;
    ctrl.objEquipe['mouvement'] = Object.assign({}, planning || { id: 0 });
    ctrl.objEquipe['chantier'] = Object.assign({}, planning['chantier']);
    ctrl.objEquipe['chauffeur'] = Object.assign({}, planning['chauffeur']);
    ctrl.objEquipe['chauffeur'].libelleObjetEntite = ctrl.objEquipe['chauffeur'] && ctrl.objEquipe['chauffeur'].id ?
      `${ctrl.objEquipe['chauffeur'].matricule || ''} ${ctrl.objEquipe['chauffeur'].nom ||
      ''} ${ctrl.objEquipe['chauffeur'].prenom || ''}` : '';
    ctrl.objEquipe['lieuChantier'] = ctrl.objEquipe['chauffeur'] ?
      ctrl.objEquipe['chauffeur'].lieuChantier : { id: 0, libelleObjetEntite: 'Non spécifié' };
    ctrl.objEquipe['lieuDepart'] = ctrl.objEquipe['chauffeur'] ?
      ctrl.objEquipe['chauffeur'].lieuDepart : { id: 0, libelleObjetEntite: 'Non spécifié' };
    const benne = data['materielLoue'] || {};
    if (benne) {
      ctrl.objEquipe['modeEquipe'] = benne.equipeDefinie || false;
      ctrl.objEquipe['program'] = benne.clefProgram && (benne.clefProgram !== '' || benne.clefProgram !== '0') ? true : false;
      ctrl.objEquipe['qualificationLeader'] = benne.qualificationLeader;
      ctrl.objEquipe['leaderEquipe'] = benne.leaderEquipe || { id: 0 };
      ctrl.objEquipe['leaderEquipe']['libelleObjetEntite'] = ctrl.objEquipe['leaderEquipe'] && ctrl.objEquipe['leaderEquipe'].id ?
        `${ctrl.objEquipe['leaderEquipe']['matricule']
        || ''} ${ctrl.objEquipe['leaderEquipe']['nom']
        || ''} ${ctrl.objEquipe['leaderEquipe']['prenom'] || ''}` : '';
      ctrl.objEquipe['lieuChantierParDefaut'] = ctrl.objEquipe['leaderEquipe'] ?
        ctrl.objEquipe['leaderEquipe'].lieuChantier : { id: 0, libelleObjetEntite: 'Non spécifié' };
      ctrl.objEquipe['lieuDepartParDefaut'] = ctrl.objEquipe['leaderEquipe'] ?
        ctrl.objEquipe['leaderEquipe'].lieuDepart : { id: 0, libelleObjetEntite: 'Non spécifié' };
      // if (ctrl.objEquipe['program']) {
      benne.listePersonnelParPoste = benne.listePersonnelParPoste || [];

      const posteMax = benne.listePersonnelParPoste.length > poctuelPost.length ? benne.listePersonnelParPoste.length : poctuelPost.length;

      console.log('parseMouvement() 1 this.equipes= -> ', this.equipes);
      console.log('parseMouvement() 2 this.objEquipe -> ', this.objEquipe);

      if (!this.equipes['listePersonnelParPoste']) {
        this.equipes['listePersonnelParPoste'] = []
      }

      this.equipes['listePersonnelParPoste'].forEach((element, i) => {
        const elt = poctuelPost[i] ? Object.assign({}, poctuelPost[i]) : { id: 0 };
        const objpost = Object.assign({}, element || { id: 0 });
        if (!poctuelPost[i]) {
          objpost.id = elt.id;
        }
        console.log(objpost, elt)
        elt.chauffeur = elt.chauffeur || { id: 0 };

        if (isAdd) {
          if (objpost['chauffeur'] && !objpost['chauffeur'].posteSupprime) {
            objpost['chauffeur'] = elt.chauffeur;
          }
        } else {
          objpost['chauffeur'] = elt.chauffeur;
        }


        elt.chauffeur['libelleObjetEntite'] = elt.chauffeur && elt.chauffeur.id ? `${elt.chauffeur['matricule'] ||
          ''}${elt.chauffeur['nom'] || ''} ${elt.chauffeur['prenom'] || ''}` : '';

        if (objpost.personnelDefaut) {
          objpost.personnelDefaut['libelleObjetEntite'] = objpost.personnelDefaut &&
            objpost.personnelDefaut.id ? `${objpost.personnelDefaut['matricule'] ||
            ''}${objpost.personnelDefaut['nom'] || ''} ${objpost.personnelDefaut['prenom'] || ''}` : '';
        }

        objpost['poste'] = elt.poste || objpost['poste']; // objpost['poste'] || elt.poste;

        objpost['lieuChantierParDefaut'] = elt['chauffeur'] ?
          elt['chauffeur'].lieuChantier : { id: 0, libelleObjetEntite: 'Non spécifié' };
        objpost['lieuDepartParDefaut'] = elt['chauffeur'] ?
          elt['chauffeur'].lieuDepart : { id: 0, libelleObjetEntite: 'Non spécifié' };
        ctrl.objEquipe['listePersonnelParPoste'].push(objpost);
      });

      console.log('parseMouvement() 3 this.equipes= -> ', this.equipes);
      console.log('parseMouvement() 4 this.objEquipe -> ', this.objEquipe);
    }

    delete this.selectedLocation['isAdd'];
  }


  listePersonnelParPoste() {
    this.objEquipe['listePersonnelParPoste'] = this.objEquipe['listePersonnelParPoste'] || [];
    return this.objEquipe['listePersonnelParPoste'].filter(elt => !elt.chauffeur || (elt.chauffeur && !elt.chauffeur.posteSupprime));
  }

  calculDate() {
    if (this.isEdit) {
      if (!this.selectedLocation['changeEnd']) {
        const debut = this.selectedLocation.dateDebut + ' ' + this.selectedLocation.heureDebut;
        const fin = this.selectedLocation.dateFin + ' ' + this.selectedLocation.heureFin;
        const diff = (this.common.getDiffDate(debut, fin, false, true));
        const date = moment(this.selectedLocation['dateStart']).add(diff, 'days').format('DD/MM/YYYYY');
        this.selectedLocation['dateEnd'] = this.common.parseDate(date);
      }
    } else {
      if (!this.selectedLocation['changeEnd']) {
        this.selectedLocation['dateEnd'] = this.selectedLocation['dateStart'];
      }
    }
  }

  calculHour() {
    if (this.isEdit) {
      const debut = this.selectedLocation.heureDebut;
      const fin = this.selectedLocation.heureFin;
      const diff = (this.common.getDiffDate(debut, fin, true));
      const start = new Date().setHours((this.selectedLocation['hourStart'] || '00'), (this.selectedLocation['minStart'] || '00'));
      const hfin = moment(start).add(diff, 'hours');
      this.selectedLocation['hourEnd'] = hfin.format('HH');
      this.selectedLocation['minEnd'] = hfin.format('mm');
    } else {
      if (this.selectedLocation['hourStart']) {
        this.selectedLocation['hourStart'] = this.selectedLocation['hourStart'] || '00';
        this.selectedLocation['minStart'] = this.selectedLocation['minStart'] || '00';
        this.changeHeureDebut();
      }
    }
  }

  changeHeureDebut() {
    if (this.selectedLocation['minStart'].length === 2) {
      const date = new Date();
      const heure = this.selectedLocation['hourStart'] ? parseInt(this.selectedLocation['hourStart'], 10) + 1 : 0;
      const st = '' + heure;
      const start = moment(date.setHours(heure, (this.selectedLocation['minStart'] || '00')));
      this.selectedLocation['hourEnd'] = start.format('HH:mm:ss').slice(0, -6);
      this.selectedLocation['minEnd'] = this.selectedLocation['minStart'];
    }
  }

  changeDatePlanning(item) {
    const val = this.selectedLocation[item];
    console.log(item, val);
    if (val && typeof val === 'string') {
      const type = val.match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/) ? true : false;
      if (type) {
        this.selectedLocation[item] = this.common.parseDate(val);
        console.log(item, this.selectedLocation[item])
      }
    }
  }

  testHour() {
    const start = new Date().setHours((this.selectedLocation['hourStart'] || '00'), (this.selectedLocation['minStart'] || '00'));
    const fin = new Date().setHours((this.selectedLocation['hourEnd'] || '00'), (this.selectedLocation['minEnd'] || '00'));
    const hstart = moment(start).format('HH:mm:ss');
    const hend = moment(fin).format('HH:mm:ss');
    const diff = (this.common.getDiffDate(hstart, hend, true));
    return diff;
  }


  saveLocation() {
    // Positionnement date/heure
    const date = new Date(this.selectedLocation['dateStart']);
    const start = moment(date.setHours((this.selectedLocation['hourStart'] || '00'), (this.selectedLocation['minStart'] || '00')));
    const end = moment(date.setHours((this.selectedLocation['hourEnd'] || '00'), (this.selectedLocation['minEnd'] || '00')));
    this.selectedLocation['dateDebut'] = moment(this.selectedLocation['dateStart']).format('DD/MM/YYYY');
    this.selectedLocation['dateFin'] = moment(this.selectedLocation['dateEnd']).format('DD/MM/YYYY');
    this.selectedLocation['heureDebut'] = start.format('HH:mm:ss');
    this.selectedLocation['heureFin'] = end.format('HH:mm:ss');

    const siteId = this.locationMateriel && this.locationMateriel.site ?
      this.locationMateriel.site.id : this.common.user[2];
    const siteCAId = this.locationMateriel && this.locationMateriel.siteCA ?
      this.locationMateriel.siteCA.id : this.common.user[2];
    this.selectedLocation['site'] = { id: siteId, nomclass: 'SiteEntreprise' };
    this.selectedLocation['siteCA'] = { id: siteCAId, nomclass: 'SiteEntreprise' };

    const temp = [];
    if (!this.selectedLocation.id && !this.selectedLocation.idx) {
      this.selectedLocation['idx'] = this.getNewIdx();
      this.listeLocationsSupplementaires.push(this.selectedLocation);
      this.listeLocationsSupplementaires = [...this.listeLocationsSupplementaires];
    } else {
      this.listeLocationsSupplementaires.forEach(elt => {
        if ((this.selectedLocation['id'] && this.selectedLocation['id'] === elt.id) ||  // modification d'une location existante
          (this.selectedLocation['idx'] && this.selectedLocation['idx'] === elt.idx)) { // modification d'une nouvelle location
          elt = this.selectedLocation;
        }
        temp.push(elt);
      });
      this.listeLocationsSupplementaires = temp;
      this.listeLocationsSupplementaires = [...this.listeLocationsSupplementaires];
    }

    this.calcHeightTab();
    console.log(this.listeLocationsSupplementaires);
    this.isEditLocation = !this.isEditLocation;
  }

  fermerLocation() {
    this.isEditLocation = !this.isEditLocation;
    this.isEdit = false;
  }

  nextFocus() {
    $('#infosup').focus();
  }

  countRowsInText(text) {
    if (text) {
      const numerOfRowsInText = text.length ? text.split(/\r*\n/).length : 0;
      return numerOfRowsInText <= 3 ? 3 : 10;
    } else {
      return 3;
    }
  }

  getNewIdx() {
    let i = this.listeLocationsSupplementaires.length - 1;
    let idx = 0;
    for (i; i >= 0; i--) {
      const location = this.listeLocationsSupplementaires[i];
      if (location['idx']) {
        idx = location['idx'];
        break;
      }
    }

    return idx + 1;
  }

  selectDate($event, id) {

    this.common.focusElement(id);
  }

  closeAll(d1, d2) {
    if (d1) {
      d1.close();
    }
    if (d2) {
      d2.close();
    }
  }

  showEquipeFct() {
    this.objEquipe['id'] = this.selectedLocation['id'] || 0;
    this.objEquipe['program'] = this.selectedLocation['program'] || false;
    this.isModeEquipe = !this.isModeEquipe;
  }

  saveEquipe(event) {
    this.objEquipe = Object.assign({}, event);
    this.selectedLocation['chauffeur'] = this.objEquipe['chauffeur'];
    this.equipes.leaderEquipe = this.objEquipe['leaderEquipe'] || { id: 0 };
    this.equipes.leaderEquipe.lieuChantier = this.objEquipe['lieuChantierParDefaut'] || { id: 0 };
    this.equipes.leaderEquipe.lieuDepart = this.objEquipe['lieuDepartParDefaut'] || { id: 0 };
    this.equipes.qualificationLeader = this.objEquipe['qualificationLeader'] || { id: 0 };
    this.selectedLocation['listePersonnelParPoste'] = [];
    this.equipes['listePersonnelParPoste'] = [];

    if (!this.copyEquipe['listePersonnelParPoste']) {
      this.copyEquipe['listePersonnelParPoste'] = [];
    }

    this.objEquipe['listePersonnelParPoste'].forEach(equipe => {
      const objToPush = Object.assign({}, equipe);
      const existePostAvant = this.copyEquipe['listePersonnelParPoste'].filter(equipeMatLoue => equipe.poste && equipeMatLoue.poste &&
        equipe.poste.id === equipeMatLoue.poste.id)
      if (existePostAvant && existePostAvant.length) {
        const equipeAvant = existePostAvant[0];
        objToPush.chauffeur = equipeAvant.chauffeur || { id: 0 };
        objToPush.lieuChantier = equipeAvant.lieuChantier || { id: 0 };
        objToPush.lieuDepart = equipeAvant.lieuDepart || { id: 0 };
      } else {
        objToPush.chauffeur = { id: 0 };
        objToPush.lieuChantier = { id: 0 };
        objToPush.lieuDepart = { id: 0 };
      }

      this.equipes['listePersonnelParPoste'].push(objToPush);
      this.selectedLocation['listePersonnelParPoste'].push(Object.assign({}, equipe));
    });

    console.log(this.equipes, this.copyEquipe)
    this.isModeEquipe = !this.isModeEquipe;
  }

  objMvtEquipe() {
    const ObjetRetour: any = {};
    ObjetRetour.listePersonnelParPoste = [];
    ObjetRetour.listePersonnelParPosteMvt = [];
    ObjetRetour.listePostes = [];
    ObjetRetour.leaderEquipe = this.objEquipe['leaderEquipe'] || { id: 0 };
    ObjetRetour.leaderEquipe.lieuChantier = this.objEquipe['lieuChantierParDefaut'] || { id: 0 };
    ObjetRetour.leaderEquipe.lieuDepart = this.objEquipe['lieuDepartParDefaut'] || { id: 0 };
    ObjetRetour.qualificationLeader = this.objEquipe['qualificationLeader'] || { id: 0 };
    ObjetRetour.chauffeur = this.objEquipe['chauffeur'] || { id: 0 };
    ObjetRetour.chauffeur.lieuChantier = this.objEquipe['lieuChantier'] || { id: 0 };
    ObjetRetour.chauffeur.lieuDepart = this.objEquipe['lieuDepart'] || { id: 0 };
    ObjetRetour.modeEquipe = this.objEquipe['modeEquipe'] || false;
    this.objEquipe['listePersonnelParPoste'] = this.objEquipe['listePersonnelParPoste'] || [];
    let i = 0;
    this.objEquipe['listePersonnelParPoste'].forEach((elt, index) => {
      elt.poste = elt.poste || { id: 0 };
      if ((elt.poste && !elt.poste.id) || this.is_recreate) {
        i = i + 1;
      }
      console.log('is_create', this.is_recreate);
      elt.poste.id = this.is_recreate ? (-1 * (i)) : (elt.poste.id || (-1 * (i)));

      elt.poste.qualification = elt.poste.qualification || { id: 0 };
      elt.poste.qualification['nomclass'] = 'QualificationPersonnel';
      ObjetRetour.listePostes.push(elt.poste);
      const defaut = {
        id: 0,
        poste: elt.poste,
        chauffeur: {
          id: elt.personnelDefaut ? (elt.personnelDefaut.id) || 0 : 0,
          lieuChantier: elt.lieuChantierParDefaut,
          lieuDepart: elt.lieuDepartParDefaut,
        }
      };
      const ponctuel = {
        id: 0,
        poste: elt.poste,
        chauffeur: {
          id: elt.chauffeur ? (elt.chauffeur.id) || 0 : 0,
          lieuChantier: elt.lieuChantier,
          lieuDepart: elt.lieuDepart,
          posteSupprime: elt.chauffeur ? (elt.chauffeur.posteSupprime) || false : false,
        }
      }
      ObjetRetour.listePersonnelParPoste.push(defaut);
      ObjetRetour.listePersonnelParPosteMvt.push(ponctuel);
    });
    ObjetRetour.equipeDefinie = ObjetRetour.listePostes.length > 0 ? true : false;
    console.log(ObjetRetour)
    return ObjetRetour;
  }

  getDetailChantier(id) {
    const param = {
      'servlet': 'DBGetChantier',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetChantier', id]
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        return datas;
      }
    });
  }
}
